import { jsx as c, Fragment as A } from "react/jsx-runtime";
import i from "react";
import { useIsomorphicLayoutEffect as W, isServer as k } from "@indeed/indeed-hook-library";
import { Box as $ } from "@indeed/ifl-components";
const u = (r) => (r == null ? void 0 : r.key) || "", w = ({ children: r, ...e }) => /* @__PURE__ */ c(A, { children: i.isValidElement(r) ? i.cloneElement(r, e) : r }), B = ({ children: r }) => {
  const e = i.Children.toArray(r).filter(i.isValidElement), n = i.useRef(!0), s = i.useRef(/* @__PURE__ */ new Map()), a = i.useRef(e.map(u)), [, l] = i.useState(), f = /* @__PURE__ */ new Set(), p = new Set(e.map(u)), m = i.useCallback((t) => {
    s.current.delete(t), l({});
  }, []);
  return W(() => {
    n.current = !1, e.forEach((t) => {
      s.current.set(u(t), t);
    }), a.current = e.map(u);
  }), k() ? /* @__PURE__ */ c(A, { children: r }) : n.current ? e.map((t) => /* @__PURE__ */ c(w, { mounted: !0, onRemove: () => m(u(t)), children: t }, u(t))) : (a.current.forEach((t) => {
    !p.has(t) && s.current.has(t) && f.add(t);
  }), f.forEach((t) => {
    e.splice(a.current.indexOf(t), 0, s.current.get(t));
  }), /* @__PURE__ */ c(A, { children: e.filter(Boolean).map((t) => /* @__PURE__ */ c(
    w,
    {
      mounted: !f.has(u(t)),
      onRemove: () => m(u(t)),
      children: t
    },
    u(t)
  )) }));
}, I = 0, H = 250, T = (r, e = 0) => {
  const n = performance.now(), s = {}, a = () => {
    s.id = requestAnimationFrame((l) => {
      l - n > e ? r() : a();
    });
  };
  return a(), s;
}, L = (r) => {
  r.id && cancelAnimationFrame(r.id);
}, S = ({
  mounted: r = !0,
  onRemove: e,
  onStageChange: n,
  children: s,
  timings: a,
  enter: l = !0,
  exit: f = !0,
  style: p,
  sx: m,
  ...t
}) => {
  const y = i.useRef(), [d, o] = i.useState(), [F, b] = i.useState(!1), x = i.useRef({}), D = i.useRef(!1);
  let {
    enter: { delay: h = I, duration: v = H } = {},
    exit: { delay: E = I, duration: R = H } = {}
  } = a || {};
  globalThis.matchMedia && globalThis.matchMedia("(prefers-reduced-motion: reduce)").matches && (h = 0, v = 0, E = 0, R = 0);
  const z = h + v, O = E + R;
  return W(() => (L(x.current), r ? l && !D.current ? (o("enter"), x.current = T(() => {
    o("entering");
  }), x.current = T(() => {
    o("entered"), D.current = !0;
  }, z)) : (o("entered"), D.current = !0) : f ? (o("exit"), x.current = T(() => {
    o("exiting");
  }), x.current = T(() => {
    o("exited"), b(!0);
  }, O)) : (o("exited"), b(!0)), () => {
    L(x.current);
  }), [r, l, f, z, O]), i.useEffect(() => {
    F && (e == null || e());
  }, [F, e]), i.useEffect(() => {
    d && (n == null || n(d, y.current));
  }, [d, n]), k() ? /* @__PURE__ */ c($, { ref: y, ...t, children: s }) : /* @__PURE__ */ c(
    $,
    {
      ref: y,
      className: d,
      style: {
        ...p,
        "--enterTransitionDelay": `${h}ms`,
        "--enterTransitionDuration": `${v}ms`,
        "--exitTransitionDelay": `${E}ms`,
        "--exitTransitionDuration": `${R}ms`
      },
      sx: {
        "&.enter, &.entering": {
          transitionDelay: "var(--enterTransitionDelay)",
          transitionDuration: "var(--enterTransitionDuration)"
        },
        "&.exit, &.exiting": {
          transitionDelay: "var(--exitTransitionDelay)",
          transitionDuration: "var(--exitTransitionDuration)"
        },
        "&": {
          ...m
        }
      },
      ...t,
      children: s
    }
  );
}, P = ({ children: r, onStageChange: e, axis: n = "vertical", sx: s, style: a, ...l }) => {
  const [f, p] = i.useState(0), [m, t] = i.useState(0), y = i.useCallback(
    (d, o) => {
      ["enter", "entered", "exit"].includes(d) && (p((o == null ? void 0 : o.scrollHeight) || 0), t((o == null ? void 0 : o.scrollWidth) || 0)), e == null || e(d, o);
    },
    [e]
  );
  return /* @__PURE__ */ c(
    S,
    {
      style: { "--scrollHeight": `${f}px`, "--scrollWidth": `${m}px`, ...a },
      onStageChange: y,
      sx: {
        "&.enter, &.exiting, &.exited": { opacity: 0, ...n === "horizontal" ? { inlineSize: 0 } : { blockSize: 0 }, overflow: "hidden" },
        "&.entering, &.exit": {
          opacity: 1,
          overflow: "hidden",
          ...n === "horizontal" ? { inlineSize: "var(--scrollWidth)" } : { blockSize: "var(--scrollHeight)" }
        },
        "&.entered": { opacity: 1 },
        ...s
      },
      ...l,
      children: r
    }
  );
}, V = ({ children: r, sx: e, ...n }) => /* @__PURE__ */ c(
  S,
  {
    sx: {
      "&.enter, &.exiting, &.exited": { opacity: 0 },
      "&.entering, &.entered, &.exit": { opacity: 1 },
      ...e
    },
    ...n,
    children: r
  }
), U = 400, X = ({
  children: r,
  sx: e,
  timings: n,
  direction: s,
  style: a,
  ...l
}) => /* @__PURE__ */ c(
  S,
  {
    style: { "--direction": s === "right" ? -1 : 1, ...a },
    sx: {
      position: "relative",
      "&.enter": { opacity: 0, transform: "translateX(calc(100% * var(--direction)))" },
      "&.entering": { opacity: 1 },
      "&.exit": { opacity: 1 },
      "&.exiting": { opacity: 0, transform: "translateX(calc(-100% * var(--direction)))" },
      "&.exit, &.exiting, &.exited": { "& > *": { position: "absolute", inlineSize: "100%" } },
      ...e
    },
    timings: { enter: { duration: U, ...n == null ? void 0 : n.enter }, exit: { duration: U, ...n == null ? void 0 : n.exit } },
    ...l,
    children: /* @__PURE__ */ c("div", { children: r })
  }
);
export {
  B as AnimatePresence,
  P as CollapseInOut,
  V as FadeInOut,
  X as SlideInOut,
  S as Transition
};
